import React, { useRef } from 'react'
import styles from './Team.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Team: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.team} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.ctsTitle}>
          <span className={styles.ctsTitle__sub}>あらゆるアプリ課題に、</span>
          <br />
          <span className={styles.ctsTitle__sub}>答えを出すチームがいる。</span>
        </h2>
        <p className={styles.teamText}>
          新規開発でも、リニューアルでも。
          <br />
          i3DESIGNは、<span className={styles.teamText__color}>戦略・UX/UI・開発・運用を分断せず、一つのチーム</span>
          で推進します。
          <br />
          「ユーザー体験の質」と「ビジネス成果の最大化」を両立する独自のアプローチで、
          <br />
          企画段階の迷いや、既存アプリの課題までも根本から解決。
          <br />
          “作って終わり”ではなく、“成果を生み出す”アプリ開発を実現します。
        </p>
        <figure className={styles.teamImage}>
          <img
            src="/img/LP/mobile-app-development/team_graphic_pc.webp"
            alt="戦略・UX/UI・開発・運用"
            className={styles.pc}
          />
          <img
            src="/img/LP/mobile-app-development/team_graphic_sp.webp"
            alt="戦略・UX/UI・開発・運用"
            className={styles.sp}
          />
        </figure>
        <h3 className={styles.subTitle}>
          i3DESIGNが、競合と一線を画す<span className={styles.subTitle__color}>3つの強み</span>
        </h3>
        <ul className={styles.point}>
          <li className={styles.point__item}>
            <span className={styles.point__item__number}>01/</span>
            <dl className={styles.point__item__text}>
              <dt className={styles.point__item__text__title}>UX/UIファーストの開発思想</dt>
              <dd className={styles.point__item__text__description}>
                体験を起点に設計する。それが、成果につながる最短ルートです。
              </dd>
            </dl>
          </li>
          <li className={styles.point__item}>
            <span className={styles.point__item__number}>02/</span>
            <dl className={styles.point__item__text}>
              <dt className={styles.point__item__text__title}>開発とグロースを一挙に担う</dt>
              <dd className={styles.point__item__text__description}>
                プロジェクトの入口でも出口でもなく、常に“中核”で伴走します。
              </dd>
            </dl>
          </li>
          <li className={styles.point__item}>
            <span className={styles.point__item__number}>03/</span>
            <dl className={styles.point__item__text}>
              <dt className={styles.point__item__text__title}>共創と切磋琢磨のカルチャー</dt>
              <dd className={styles.point__item__text__description}>依頼ではなく挑戦を共有し、ともに成長する。</dd>
            </dl>
          </li>
        </ul>
      </div>
    </section>
  )
}
export default Team
